<template>
  <div class="white ui-modal ui-modal--settings relative max-width-3">
        <h1 class="h1  border-box">{{$t('user-settings_heading')}}</h1>  
        <p class=" ">{{$t('user-settings_subline')}}</p>
        <p class="mb2 small color-mediumgray">{{$t('user-settings_required_fields')}}</p>
        <div class="flex col-12 flex-wrap">
          <div class="flex  col-12 align-middle mb1">
            <p class="col-3 small  ">{{$t('user-settings_email')}}</p>
            <input disabled :placeholder="userGeneralData.email" class="user-input-narrow white col-8 border-box" />
          </div>
        
            <div class=" row-sys flex col-12 mb1">
            <p class="col-3 small  " v-bind:class="{ userprofileError: gd_not_filled_vorname}">{{$t('user-settings_firstname')}}*</p>
            <input  class="user-input-narrow col-8 border-box" :placeholder="$t('user-settings_firstname_placeholder')" v-model="userGeneralData.firstname">
          </div>
     
        <div class=" row-sys flex col-12 mb1">
          <p class="col-3 small " v-bind:class="{ userprofileError: gd_not_filled_nachname}">{{$t('user-settings_lastname')}}*</p>
          <input class="user-input-narrow col-8 border-box" v-model="userGeneralData.name" :placeholder="$t('user-settings_lastname_placeholder')">
        </div>
        <div class=" row-sys flex col-12 mb1">
          <p class="col-3 small  " v-bind:class="{ userprofileError: gd_not_filled_firma}">{{$t('user-settings_company')}}*</p>
          <input class="user-input-narrow col-8 border-box" v-model="userGeneralData.company" :placeholder="$t('user-settings_company_placeholder')">
        </div>
        <div class=" row-sys flex col-12 mb1">
          <p class="col-3 small  ">{{$t('user-settings_position')}}</p>
          <input class="user-input-narrow col-8 border-box" v-model="userGeneralData.position" :placeholder="$t('user-settings_position_placeholder')">
        </div>
        <div class=" row-sys flex col-12 mb1">
          <p class="col-3 small  ">{{$t('user-settings_city')}}</p>
          <input class="user-input-narrow col-8 border-box" v-model="userGeneralData.city" :placeholder="$t('user-settings_city_placeholder')">
        </div>
        <div class=" row-sys flex col-12 mb1">
          <p class="col-3 small  ">{{$t('user-settings_country')}}</p>
          <div class="relative user-select-wrapper col-8 border-box">
            <img class="dropdown-arrow" src="../assets/dropdown-arrow.svg">
            <select class="user-input-narrow col-12" id="CountrySelect" name="CountrySelect" v-model="userGeneralData.countries_id">
              <option value="" disabled>{{$t('user-settings_country_placeholder')}}</option>
              <option v-for="country in countries_list.data" :key="country.id" :value="country.id">
                {{ country.countryname }}
              </option>
            </select> 
          </div>
        </div>
        <div class=" row-sys flex flex-wrap flex-start col-12 mb1">
          <p class="col-3 small  " v-bind:class="{ userprofileError: gd_not_filled_phone}">{{$t('user-settings_phone')}}*</p>
          <input class="user-input-narrow col-8 border-box" v-model="userGeneralData.tel" :placeholder="$t('user-settings_phone_placeholder')">
        </div>
        </div>
        <div class="flex  justify-end col-11">
          <button class="btn btn-bg-red btn-small pointer self-end mt2 mr2" @click="closeUserSettings()">{{$t('user-settings_cancel')}}</button>
          <button class="btn btn-small pointer self-end mt2" @click="updateGeneralData()">{{$t('user-settings_save_changes')}}</button>
          </div>
  </div>
</template>

<script>
import axios from 'axios';
import { EventBus } from "../event-bus";

export default {
  name: 'UserSettings',
  data() {
    return {
      debug: false,
      userGeneralData: {
        salutations_id: 0,
        firstname: '',
        name: '',
        company: '',
        tel: '',
        position: '',
        city: '',
        countries_id: 0,
      },

      gd_not_filled_anrede: false,
      gd_not_filled_vorname: false,
      gd_not_filled_nachname: false,
      gd_not_filled_firma: false,
      gd_not_filled_phone: false,
      gd_not_filled_email: false,
      gd_not_filled_city: false,
      gd_not_filled_country: false,

      generalSettingsValidated: true,

      // Login Daten
      userdata: {},
      session: {},
      loginStatus: false,

      countries_list: [],

      profileLoaded: false

    }
  },
  created() {

    axios.get(process.env.VUE_APP_APIENDPOINT + "/public-api/get-countries/json").then(response => (this.countries_list = response.data));
    
    EventBus.$on('loginSuccessfulSubComponents', (payload) => {
      this.userdata = payload.userdata;
      this.session = payload.session;
      this.loginStatus = true;
      this.loadUserData()
    });
    EventBus.$on('loadUserProfileData', () => {
      this.loadUserData()
    });
    EventBus.$on('collectDataForResultPDF-Step01', () => {
      EventBus.$emit('collectDataForResultPDF-Step02', {
        "appsettings_id": this.selected_project
      });
    });
    EventBus.$on('close_user_settings_update_modal_lightbox', () => {
      this.closeUserSettings();
    })
  },
  methods: {
    loadUserData(){
        let url = process.env.VUE_APP_APIENDPOINT + '/public-api/loadmyprofile/json';
        axios.post(url, this.session)
        .then(response => {
          //(response.data)
          this.userGeneralData = response.data.userData;
          this.profileLoaded = true;
        })
        .catch(function () {
          console.log('catch Function of AJAX-Called... error()');
        });
    },
    updateGeneralData(){

      console.log('updateGeneralData fired')

      this.generalSettingsValidated = true;


      if(this.userGeneralData.salutations_id == '') {
        this.gd_not_filled_anrede = true;
        this.generalSettingsValidated = false;
      }
      if(this.userGeneralData.firstname == '') {
        this.gd_not_filled_vorname = true;
        this.generalSettingsValidated = false;
      }
      if(this.userGeneralData.name == '') {
        this.gd_not_filled_nachname = true;
        this.generalSettingsValidated = false; 
      }
      if(this.userGeneralData.tel == '') {
        this.gd_not_filled_phone = true;
        this.generalSettingsValidated = false; 
      }
      if(this.userGeneralData.company == '') {
        this.gd_not_filled_firma = true;
        this.generalSettingsValidated = false; 
      }

      if(this.generalSettingsValidated){

        console.log('updateGeneralSettings allValidated')
          //axios Magic
        let currentObj = this;
        let data = {};
        data.userData = {};
        data.userData.firstname = currentObj.userGeneralData.firstname
        data.userData.name = currentObj.userGeneralData.name
        data.userData.company = currentObj.userGeneralData.company
        data.userData.position = currentObj.userGeneralData.position
        data.userData.city = currentObj.userGeneralData.city
        data.userData.countries_id = currentObj.userGeneralData.countries_id
        data.userData.tel = currentObj.userGeneralData.tel

        console.log(data.userData)



        let merged = {...data, ...this.session};
        axios.post(process.env.VUE_APP_APIENDPOINT + '/public-api/updatemyprofile/json', merged)
        .then(function () {currentObj.loadUserData; EventBus.$emit('close_userSettings')});
      }
    },
    closeUserSettings(){
      this.loadUserData();
        EventBus.$emit('close_userSettings');
        // this.userGeneralData.firstname = ''
        // this.userGeneralData.name = ''
        // this.userGeneralData.company = ''
        // this.userGeneralData.position = ''
        // this.userGeneralData.city = ''
        // this.userGeneralData.countries_id = ''
        // this.userGeneralData.tel = ''

    },
  }
}
</script>

<style scoped>
</style>